/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { httpErrorCodes } from "constants/enums";
import {
  getVerticalScrollbarSize,
  getHorizontalScrollbarSize,
  getPagesViewElementHandle
} from "selectors/pagedViewState";
import * as constants from "constants/constants";

export const getViewPortHeight = stores => stores.documentViewStore.height;
export const getDocumentVisibleHeight = stores => stores.documentViewStore.documentVisibleHeight;
export const getViewPortWidth = stores => stores.documentViewStore.width;
export const getFallbackPrintLoaderStatus = stores => stores.documentViewStore.showFallbackPrintLoader;
export const getViewPortHeightWithoutPagesViewScrollbar = stores =>
  getViewPortHeight(stores) - getHorizontalScrollbarSize(stores);
export const getViewPortWidthWithoutPagesViewScrollbar = stores =>
  getViewPortWidth(stores) - getVerticalScrollbarSize(stores);

export const getDocumentViewHandle = stores => stores.documentViewStore.documentViewHandle;
export const isPointInsideDocumentView = (stores, x, y) => {
  const { left, right, bottom, top } = getDocumentViewHandle(stores).getBoundingClientRect();
  return x >= left && x <= right && y >= top && y <= bottom;
};

export const getPagesViewBoundingRect = stores => {
  if (getPagesViewElementHandle(stores)) {
    let { left, right, bottom, top } = getPagesViewElementHandle(stores).getBoundingClientRect();
    right -= getVerticalScrollbarSize(stores);
    bottom -= getHorizontalScrollbarSize(stores);
    return { left, right, bottom, top };
  }
  return {};
};

export const getNoPreviewErrorCode = stores => stores.documentViewStore.noPreviewErrorCode;
export const shouldShowDownloadButton = stores =>
  getNoPreviewErrorCode(stores) === httpErrorCodes.UNSUPPORTED_MEDIA_TYPE ||
  getNoPreviewErrorCode(stores) === httpErrorCodes.NOT_FOUND;
export const shouldShowDownloadMessage = stores =>
  getNoPreviewErrorCode(stores) === httpErrorCodes.UNSUPPORTED_MEDIA_TYPE;

export const getLastPageExtraBottomSpace = stores => stores.documentViewStore.lastPageExtraBottomSpace;
